import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  Divider,
} from '@mui/material';
import {
  LocationOn,
  Email,
  Phone,
  PhoneInTalk,
} from '@mui/icons-material';

const Footer: React.FC = () => {

  return (
    <Box
      sx={{
        bgcolor: '#1e3a8a', // Primary blue color
        color: 'white',
        py: 4,
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 2, md: 4, lg: 6 } }}>
        <Grid container spacing={{ xs: 3, md: 4, lg: 5 }}>
          {/* Site Menu */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 'bold', 
                mb: 2,
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: -4,
                  left: 0,
                  width: '30px',
                  height: '2px',
                  bgcolor: 'white',
                }
              }}
            >
              Site Menü
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography 
                component={RouterLink} 
                to="/hakkimizda" 
                sx={{ 
                  color: 'white', 
                  textDecoration: 'none',
                  '&:hover': { opacity: 0.8 }
                }}
              >
                Hakkımızda
              </Typography>
              <Typography 
                component={RouterLink} 
                to="/hizmetler" 
                sx={{ 
                  color: 'white', 
                  textDecoration: 'none',
                  '&:hover': { opacity: 0.8 }
                }}
              >
                Hizmetlerimiz
              </Typography>
              <Typography 
                component={RouterLink} 
                to="/iletisim" 
                sx={{ 
                  color: 'white', 
                  textDecoration: 'none',
                  '&:hover': { opacity: 0.8 }
                }}
              >
                İletişim
              </Typography>
            </Box>
          </Grid>

          {/* Services */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 'bold', 
                mb: 2,
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: -4,
                  left: 0,
                  width: '30px',
                  height: '2px',
                  bgcolor: 'white',
                }
              }}
            >
              Hizmetlerimiz
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography 
                component={RouterLink} 
                to="/hizmetler/arac-ici-yalitim" 
                sx={{ 
                  color: 'white', 
                  textDecoration: 'none',
                  '&:hover': { opacity: 0.8 }
                }}
              >
                Araç İçi Yalıtım
              </Typography>
              <Typography 
                component={RouterLink} 
                to="/hizmetler/double-deck" 
                sx={{ 
                  color: 'white', 
                  textDecoration: 'none',
                  '&:hover': { opacity: 0.8 }
                }}
              >
                Double Deck Sistem
              </Typography>
              <Typography 
                component={RouterLink} 
                to="/hizmetler/yedek-parca" 
                sx={{ 
                  color: 'white', 
                  textDecoration: 'none',
                  '&:hover': { opacity: 0.8 }
                }}
              >
                Yedek Parça
              </Typography>
            </Box>
          </Grid>

          {/* Contact */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 'bold', 
                mb: 2,
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: -4,
                  left: 0,
                  width: '30px',
                  height: '2px',
                  bgcolor: 'white',
                }
              }}
            >
              İletişim
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email sx={{ fontSize: 20, color: 'white' }} />
                <Typography variant="body2">kaletreyler@gmail.com</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ fontSize: 20, color: 'white' }} />
                <Typography variant="body2">+90 545 288 72 93 
                  Ömer Bozkurt
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneInTalk sx={{ fontSize: 20, color: 'white' }} />
                <Typography variant="body2">+90 553 181 23 95
                  Yusuf Bozkurt
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Call Me Section */}
          <Grid item xs={12} sm={6} md={2.5}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 'bold', 
                mb: 2,
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: -4,
                  left: 0,
                  width: '30px',
                  height: '2px',
                  bgcolor: 'white',
                }
              }}
            >
              Sizi Arayalım
            </Typography>
            
           

            <Button
              component={RouterLink}
              to="/iletisim"
              variant="contained"
              sx={{
                bgcolor: '#1e40af',
                color: 'white',
                px: 1,
                py: 1.5,
                fontSize: '1rem',
                fontWeight: 'bold',
                borderRadius: 2,
                '&:hover': {
                  bgcolor: '#1d4ed8',
                  transform: 'translateY(-2px)',
                },
                transition: 'all 0.3s ease',
                textTransform: 'none',
              }}
            >
              İletişim Sayfasına Git
            </Button>
          </Grid>

          {/* Address Section */}
          <Grid item xs={12} sm={6} md={2.5}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 'bold', 
                mb: 2,
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: -4,
                  left: 0,
                  width: '30px',
                  height: '2px',
                  bgcolor: 'white',
                }
              }}
            >
              Adres
            </Typography>
            
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <LocationOn sx={{ fontSize: 20, color: 'white', mt: 0.5 }} />
              <Typography variant="body2">
                Dikilitaş Mah. Cumhuriyet-5 Cad. No: 118/B<br />
                MIG Mersin Tır Parkı İçerisinde<br />
                Akdeniz / Mersin
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,0.2)' }} />

        {/* Copyright */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Copyrights © 2024 <strong>Kale Treyler</strong>. All Rights Reserved. | Web Tasarım
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
